import React from "react";
import {Alert, Button, Modal, Spinner} from "react-bootstrap";
import {MESSAGES as Messages} from "../util/Messages";
import {RecoverPasswordQuery} from "../apollo/queries/RecoverPasswordQuery";
import {Query} from "react-apollo";
import {ApolloClient, ApolloLink, HttpLink, InMemoryCache} from "apollo-boost";

let customHttpLink;

if (process.env.PUBLIC_URL.indexOf('appsprod') >= 0) {
  customHttpLink = new HttpLink({uri: 'https://appsprod.cibercolegios.com/api/security'});
} else {
  customHttpLink = new HttpLink({uri: 'https://appstest.cibercolegios.com/api/security'});
}

const customAuthLink = new ApolloLink((operation, forward) => {
  let loc = window.location.href;
  operation.setContext({
    headers: {
      auth_token: loc.split("/")[loc.split("/").length - 1]
    }
  });

  return forward(operation);
});

const customClient = new ApolloClient({
  link: customAuthLink.concat(customHttpLink), // Chain it with the HttpLink
  cache: new InMemoryCache()
});


class PasswordModal extends React.Component {

  state = {
    show: false,
    email: ''
  };

  handleClose = () => {
    this.setState({
      show: false
    });
  };

  handleShow = () => {
    this.setState({
      show: true
    })
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  };

  sendPassword = () => {
    console.log("Enviando password");
    this.setState({
      send: true
    })
  };

  render() {

    return (
      <>
        <a href="#" onClick={this.handleShow}>
          Olvidé mi contraseña
        </a>
        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Olvidé mi contraseña</Modal.Title>
          </Modal.Header>
          <Modal.Body>{Messages.OLVIDO_CONTRASENIA}
            <br/>
            {this.state.send &&
            <Query query={RecoverPasswordQuery} fetchPolicy={"network-only"} client={customClient}
              variables={{email: this.state.email}}>
              {({loading, error, data}) => {
                console.log("Dataaaa", data);
                if (loading) {
                  return (
                    <Spinner animation="border" role="status"><span className="sr-only">Loading...</span></Spinner>)
                } else if (data) {
                  return (<Alert variant="success">
                    Se envió la contraseña al correo electrónico registrado
                  </Alert>)
                } else if (error) {
                  return (<Alert variant="warning">
                    Hubo un error al tratar de recuperar su password, contacte al administrador
                  </Alert>)
                } else {
                  return (<></>)
                }
              }}
            </Query>}
            <input type="text"
              id="email"
              name="email"
              className="form-control"
              placeholder="Email"
              required
              onChange={e => this.handleChange(e)}
              value={this.state.email}
              autoFocus/>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleClose}>
              Cerrar
            </Button>
            <Button variant="primary" onClick={this.sendPassword} disabled={!this.state.email}>
              Enviar
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default PasswordModal;